import { remoteConfig } from 'boot/firebase';
import { fetchAndActivate } from 'firebase/remote-config';
import { getConfigValue, REFRESH_INTERVAL, REMOTE_CONFIG_KEYS } from 'src/utils/RemoteConfig';

export default {
  async fetchConfig() {
    const isStale = !this.lastFetchedAt || (Date.now() - this.lastFetchedAt) > REFRESH_INTERVAL;
    if (!isStale) {
      return;
    }

    try {
      await fetchAndActivate(remoteConfig);
      this.config = {};

      Object.values(REMOTE_CONFIG_KEYS).forEach(({ key, type }) => {
        this.config[key] = getConfigValue(key, type);
      });

      this.lastFetchedAt = Date.now();
    } catch (error) {
      console.error('Remote Config refresh failed:', error);
    }
  }, // fetchConfig()

  async getRemoteConfigValue(key) {
    const isKnownKey = Object.values(REMOTE_CONFIG_KEYS).some(({ key: knownKey }) => knownKey === key);
    if (!isKnownKey) {
      return null;
    }
    await this.fetchConfig();
    return this.config[key] ?? null;
  }, // getRemoteConfigValue()
};
